import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  response: null,
  error: null,
};

const GetTcSlice = createSlice({
  name: "getTc",
  initialState,
  reducers: {
    getTcRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getTcRequestSuccess: (state, action) => {
      state.loading = false;
      state.response = action.payload;
      state.error = null;
    },
    getTcRequestError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getTcRequest,
  getTcRequestSuccess,
  getTcRequestError,
} = GetTcSlice.actions;

export default GetTcSlice.reducer;
